import { render, staticRenderFns } from "./transactions-page-filters.vue?vue&type=template&id=bc95dbbe&scoped=true&"
import script from "./transactions-page-filters.vue?vue&type=script&lang=js&"
export * from "./transactions-page-filters.vue?vue&type=script&lang=js&"
import style0 from "./transactions-page-filters.vue?vue&type=style&index=0&id=bc95dbbe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc95dbbe",
  null
  
)

export default component.exports